import(/* webpackMode: "eager" */ "C:\\Users\\Administrator\\Downloads\\esiptvpro.fr\\app\\application\\page.tsx");
